import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Redirect, Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import { toast } from 'react-toastify';
import { usersRef, childrenRef } from '../firebase';

const styles = theme => ({
    title: {
        paddingLeft: '2%',
        paddingRight: '5%',
        paddingTop: '2%',
        paddingBottom: '5rem',
    },
    close: {
        width: theme.spacing.unit * 4,
        height: theme.spacing.unit * 4,
    },
});

class Account extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            saving: false,
            kids: [],
        }
    }
    
    componentDidMount() {
        const { myId } = this.props
        usersRef.doc(myId).get()
        .then((snapshot) => {
            const { firstName, lastName, phone, paypalId } = snapshot.data();
    
            childrenRef.where('parentId', '==', myId).get()
                .then(querySnap => {
                    let kids = []

                    querySnap.forEach(doc => {
                        const { firstName, lastName } = doc.data()
                        kids.push(firstName + ' ' + lastName)
                    })

                    this.setState({
                        firstName,
                        lastName,
                        phone,
                        kids,
                        paypalId,
                        loading: false,
                    });
                })

        });
    }

    onSubmit = () => {
        if (!this.state.saving) {
            if (this.state.firstName === '' || this.state.lastName === '' || this.state.email === ''
                || this.state.phone === '') {
                /* Push.create("KBAAZ", {
                    body: "Please fillout all fields!!!",
                    logo: './k-logo.png',
                    timeout: 4000,
                    onClick: function() {
                        window.focus();
                        this.close();
                    }
                }); */
                toast.warn('Please fill out all fields!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });

            } else {
                this.setState({ saving: true });
                const userData = {
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    phone: this.state.phone,
                    paypalId: this.state.paypalId,
                }

                usersRef.doc(this.props.myId).update(userData)
                .then(() => {
                    /* Push.create("KBAAZ", {
                        body: "Child saved successfully",
                        logo: './k-logo.png',
                        timeout: 4000,
                        onClick: function () {
                            window.focus();
                            this.close();
                        }
                    }); */
                    toast.success('Account saved successfully!', {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    this.setState({ saving: false, redirect: true });
                })
                .catch(() => {
                    /* Push.create("KBAAZ", {
                        body: "Error occurred",
                        logo: './k-logo.png',
                        timeout: 4000,
                        onClick: function () {
                            window.focus();
                            this.close();
                        }
                    }); */
                    toast.error('Error occurred!', {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    this.setState({ saving: false });
                });
            }
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    render() {
        const { classes } = this.props;

        if (this.state.redirect) {
            return (
                <Redirect to="/kids" />
            );
        }

        if (this.state.loading) {
            return (
                <h2>Loading...</h2>
            );
        }

        return (
            <div className={classes.title}>
                <Grid container spacing={40} style={{ paddingBottom: '50px' }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography gutterBottom={false} color="primary" variant="display1">Account Details</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextField value={this.state.firstName} onChange={this.handleChange('firstName')} style={{ width: '80%' }} label={"First Name"} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextField value={this.state.lastName} onChange={this.handleChange('lastName')} style={{ width: '80%' }} label={"Last Name"} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextField value={this.state.phone} onChange={this.handleChange('phone')} style={{ width: '80%' }} label={"Phone"} />
                    </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography gutterBottom={false} color="primary" variant="display1">Kids</Typography>
                </Grid>
                    {
                        this.state.kids.map(kid => (
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Typography gutterBottom={false} variant="p">{kid}</Typography>
                            </Grid>
                        ))
                    
                    }
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Link to="/kids/add" style={{ textDecoration: 'none' }}>
                            <Button variant="outlined">+ ADD NEW CHILD</Button>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography gutterBottom={false} color="primary" variant="display1">Paypal Marketplace ID</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextField value={this.state.paypalId} onChange={this.handleChange('paypalId')} style={{ width: '80%' }} label={"Paypal ID"} />
                    </Grid>
                </Grid>
                <Button onClick={this.onSubmit} variant="outlined">SAVE</Button>
            </div>
        );
    }
}

Account.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Account);



// WEBPACK FOOTER //
// ./src/components/Account.js